import styled, { css } from 'styled-components';

export const RightPanel = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.background.paper};
  overflow: hidden;
`;

export const RightPanelImage = styled.img<{
  $maxWidth: number;
  $relative: boolean;
}>`
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};

  ${({ $relative }) =>
    !$relative &&
    css`
      position: absolute;

      top: 50%;
      left: 20%;

      transform: translateY(-50%);
    `};
`;
